import { render, staticRenderFns } from "./TextboxSettings.vue?vue&type=template&id=542863f8&"
import script from "./TextboxSettings.vue?vue&type=script&lang=js&"
export * from "./TextboxSettings.vue?vue&type=script&lang=js&"
import style0 from "./TextboxSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports